// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrganizationOverviewServerTableQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type OrganizationOverviewServerTableQuery = {
  __typename?: "GraphqlQuery";
  getSummaryStatsByServer: Array<{
    __typename?: "ServerSummaryStats";
    id: string;
    databaseCount: number;
    criticalsCount: number;
    warningsCount: number;
    queriesSlownessCount: number;
    unusedIndexesCount: number;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
      hasRecentSnapshot: boolean;
      hasCriticalIssues: boolean;
      tags: Array<{
        __typename?: "ServerTag";
        key: string;
        value: string;
        source: string;
      }>;
      latestStats?: {
        __typename?: "PostgresServerStats";
        isPrimary: boolean;
      } | null;
    };
  }>;
};

export const OrganizationOverviewServerTableDocument = gql`
  query OrganizationOverviewServerTable($organizationSlug: ID!) {
    getSummaryStatsByServer(organizationSlug: $organizationSlug) {
      id
      server {
        id
        humanId
        name
        hasRecentSnapshot
        hasCriticalIssues
        tags {
          key
          value
          source
        }
        latestStats {
          isPrimary
        }
      }
      databaseCount
      criticalsCount
      warningsCount
      queriesSlownessCount
      unusedIndexesCount
    }
  }
`;

/**
 * __useOrganizationOverviewServerTableQuery__
 *
 * To run a query within a React component, call `useOrganizationOverviewServerTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOverviewServerTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOverviewServerTableQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOrganizationOverviewServerTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationOverviewServerTableQuery,
    OrganizationOverviewServerTableQueryVariables
  > &
    (
      | {
          variables: OrganizationOverviewServerTableQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationOverviewServerTableQuery,
    OrganizationOverviewServerTableQueryVariables
  >(OrganizationOverviewServerTableDocument, options);
}
export function useOrganizationOverviewServerTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationOverviewServerTableQuery,
    OrganizationOverviewServerTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationOverviewServerTableQuery,
    OrganizationOverviewServerTableQueryVariables
  >(OrganizationOverviewServerTableDocument, options);
}
// @ts-ignore
export function useOrganizationOverviewServerTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationOverviewServerTableQuery,
    OrganizationOverviewServerTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationOverviewServerTableQuery,
  OrganizationOverviewServerTableQueryVariables
>;
export function useOrganizationOverviewServerTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationOverviewServerTableQuery,
        OrganizationOverviewServerTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationOverviewServerTableQuery | undefined,
  OrganizationOverviewServerTableQueryVariables
>;
export function useOrganizationOverviewServerTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationOverviewServerTableQuery,
        OrganizationOverviewServerTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationOverviewServerTableQuery,
    OrganizationOverviewServerTableQueryVariables
  >(OrganizationOverviewServerTableDocument, options);
}
export type OrganizationOverviewServerTableQueryHookResult = ReturnType<
  typeof useOrganizationOverviewServerTableQuery
>;
export type OrganizationOverviewServerTableLazyQueryHookResult = ReturnType<
  typeof useOrganizationOverviewServerTableLazyQuery
>;
export type OrganizationOverviewServerTableSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationOverviewServerTableSuspenseQuery
>;
export type OrganizationOverviewServerTableQueryResult = Apollo.QueryResult<
  OrganizationOverviewServerTableQuery,
  OrganizationOverviewServerTableQueryVariables
>;
